module.exports = __webpack_public_path__ + "img/mash-about.16ffa0f7.jpg";